import React from 'react';
import { createRoot } from 'react-dom/client';
import ServiceBookingApp from './Presentation/Organism/ServiceBooking/app/src/ServiceBookingApp';
import { initI18n } from './Presentation/Organism/ServiceBooking/app/src/i18n';

const container = document.getElementById('service-booking');
if (container) {
    const locale = container.dataset.locale || 'en';
    const translations = JSON.parse(container.dataset.translations || '{}');

    initI18n(locale, translations);

    createRoot(container).render(<ServiceBookingApp />);
}
